import config from '@feature-config/core/api-tester/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { ApiTesterFeature } from './ApiTesterFeature';

const apiTesterFeature: FeatureModule = createFeatureModule(
  config,
  ApiTesterFeature,
  'core/api-tester'
);

export default apiTesterFeature;
